import { cn } from "@utils";

const Badge = ({ children, color }) => {
  return (
    <span
      className={cn(
        "inline-flex items-center rounded-md px-2 py-1 text-xs font-medium ring-1 ring-inset max-h-6 shrink-0",
        color === "yellow" && "bg-yellow-50 text-yellow-800 ring-yellow-600/20",
        color === "green" && "bg-green-50 text-green-800 ring-green-600/20",
        color === "red" && "bg-red-50 text-red-800 ring-red-600/10",
        color === "zinc" && "bg-zinc-50 text-zinc-800 ring-zinc-500/10",
        color === "blue" && "bg-blue-50 text-blue-800 ring-blue-700/10",
        color === "fuchsia" && "bg-fuchsia-50 text-fuchsia-700 ring-fuchsia-600/20"
      )}
    >
      {children}
    </span>
  );
};

export default Badge;
